import { render } from "./doctor-request-modal.vue?vue&type=template&id=8ec89a5c"
import script from "./doctor-request-modal.vue?vue&type=script&lang=js"
export * from "./doctor-request-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__